export const certificates = [
  {
    title: "Fundamental Algorithms: Design and Analysis",
    issuer: "NPTEL",
    year: "2023",
  },
  {
    title: "Database Management System",
    issuer: "NPTEL",
    year: "2023",
  },
  {
    title: "Artificial Intelligence with Python",
    issuer: "SkillForge",
    year: "2024",
  },
];
